import styled from "@emotion/styled";
import { TwitterEmbed } from "@product/react-social-media-embed";
import type { FunctionComponent } from "react";
import { useMemo } from "react";

import type { ContentSchemaRenderProps } from "scmp-app/components/schema-render/content";

import { TweetContainer } from "./styles";

const hasPictureLink = (node: SchemaNode): boolean => {
  if (node.data?.startsWith("pic.twitter.com/")) {
    return true;
  }
  if (node.children) {
    return node.children.some(child => hasPictureLink(child));
  }
  return false;
};

const getTweetUrl = (node: SchemaNode): string => {
  if (node.subtype === ("twitter" as SchemaSubtype)) {
    return node.attribs?.href ?? "";
  }
  if (node.children) {
    for (const [_, child] of node.children.entries()) {
      const url = getTweetUrl(child);
      if (url) return url;
    }
  }
  return "";
};

const Component: FunctionComponent<ContentSchemaRenderProps> = ({ schemaNode }) => {
  const tweetHasMedia = useMemo(() => hasPictureLink(schemaNode), [schemaNode]);
  const tweetUrl = useMemo(() => getTweetUrl(schemaNode), [schemaNode]);

  return (
    tweetUrl && (
      <TweetContainer $hasMedia={tweetHasMedia}>
        <TwitterEmbed placeholderDisabled url={tweetUrl} />
      </TweetContainer>
    )
  );
};

Component.displayName = "BlockquoteTwitter";

export const BlockquoteTwitter = styled(Component)``;
